import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { backenddataService } from './../backenddata/backenddata.service';

@Injectable()
export class authinterceptorService implements HttpInterceptor {
    constructor(private _bdService: backenddataService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this._bdService.setHttpInProgress(true);

        return next.handle(req).pipe(
            finalize(() => {
                this._bdService.setHttpInProgress(false);
            })
        );
    }
}
